import { getUrlSetting } from '../utils'

let instance = null

const ConfigManager = () => {
  if (instance) return instance

  const CONFIG_PRESETS = {
    default: {
      cameraZoom: 3,
      previewMode: 0,
      showNavigation: true,
      showFooter: true,
      showLogo: true,
      matchEngineVersion: 2,
      maxDetectDistanceFromCenterOfReticle: 30,
      preferredCameraResolution: '1080p',
      scanImageFileFormat: 'p',
      scanImageCompressionQuality: 0.92,
      scanImageCropByTagRadius: 2,
      scanImageCropByQRCodeWidth: 1.4,
      circleDetection: 'enabled',
      qrCodeDetection: 'disabled',
      qrCodeMinimumSize: 115,
      qrCodeMaximumSize: 0, // 0 means no maximum size
      qrCodeMinimumBlurRatio: 0, // came up with this number using a gs1_qr_2 tag and Huawei P30l
      scanType: 'fingerprint',
      maximumScanFrequencyInMs: 500,
      scanTimeoutInMilliseconds: 15000,
      sendingForVerificationDisplayTimeoutInMilliseconds: 1500,
      scanReticle: 'enabled',
      scanReticleShape: 'circle',
      scanReticleBorderStroke: 'dashed',
      scanReticleWidth: 150,
      scanReticleHeight: 150,
      scanReticleColourChange: 'disabled',
      scanReticleThickness: 2,
      reticleFingerprint: 'enabled',
      digitalAnticopyAlgorithm: '',
      finalImagelongestEdgeLength: 1000,
      nonCircleDetectionCropSize: 900,
      qrDetectionCropSize: 900,
      qrScanRegionFractionOfImage: 0.5,
      qrCodeParsing: 'enabled',
      waitForReply: 'enabled',
      platform: 'web',
      legacyScannerButton: 'disabled',
      legacyScannerLink: '?cfg=da',
      resetTimeoutOnUseEffect: 'enabled',
      contextScan: 'enabled',
      contextScanImageFileFormat: 'p',
      contextScanImageCompressionQuality: 0.8,
      contextNonCircleDetectionCropSize: 900,
      contextFinalImagelongestEdgeLength: 1000,
    },
    da: {
      circleDetection: 'disabled',
      scanImageFileFormat: 'j',
      maximumScanFrequencyInMs: 1000,
      sendingForVerificationDisplayTimeoutInMilliseconds: 60000, //Make this value arbitrarily large so that it's effectively disabled for digital_anticopy scans
      reticleFingerprint: 'disabled',
      scanImageCompressionQuality: 0.9,
      scanImageCropByTagRadius: 0,
      scanReticle: 'disabled',
      waitForReply: 'disabled',
      contextScan: 'disabled',
      contextScanImageFileFormat: 'j',
    },
    sqr: {
      scanImageFileFormat: 'j',
      scanImageCompressionQuality: 0.9,
      qrCodeDetection: 'enabled',
      qrCodeParsing: 'disabled',
      reticleFingerprint: 'disabled',
      scanTimeoutInMilliseconds: 25000,
      circleDetection: 'disabled',
      scanReticle: 'enabled',
      scanReticleShape: 'square',
      scanReticleWidth: 150,
      scanReticleHeight: 150,
      maxDetectDistanceFromCenterOfReticle: 300,
      scanReticleColourChange: 'enabled',
      scanReticleBorderStroke: 'solid',
      legacyScannerButton: 'enabled',
      resetTimeoutOnUseEffect: 'disabled',
      contextScanImageFileFormat: 'j',
    },
    dalsf: {
      scanImageFileFormat: 'j',
      scanImageCompressionQuality: 0.9,
      scanTimeoutInMilliseconds: 25000,
      contextScanImageFileFormat: 'j',
    },
    orionb: {
      circleDetection: 'disabled',
      scanImageFileFormat: 'j',
      maximumScanFrequencyInMs: 1000,
      sendingForVerificationDisplayTimeoutInMilliseconds: 60000, //Make this value arbitrarily large so that it's effectively disabled for digital_anticopy scans
      reticleFingerprint: 'disabled',
      scanImageCompressionQuality: 0.9,
      scanImageCropByTagRadius: 0,
      scanReticle: 'disabled',
      waitForReply: 'disabled',
      contextScanImageFileFormat: 'j',
    },
    condot: {
      circleDetection: 'disabled',
      scanImageFileFormat: 'j',
      maximumScanFrequencyInMs: 1000,
      sendingForVerificationDisplayTimeoutInMilliseconds: 60000, //Make this value arbitrarily large so that it's effectively disabled for digital_anticopy scans
      reticleFingerprint: 'disabled',
      scanImageCompressionQuality: 0.9,
      scanImageCropByTagRadius: 0,
      scanReticle: 'disabled',
      waitForReply: 'disabled',
      contextScanImageFileFormat: 'j',
    },
    odemo: {
      circleDetection: 'disabled',
      scanImageFileFormat: 'j',
      maximumScanFrequencyInMs: 1000,
      sendingForVerificationDisplayTimeoutInMilliseconds: 60000, //Make this value arbitrarily large so that it's effectively disabled for digital_anticopy scans
      reticleFingerprint: 'disabled',
      scanImageCompressionQuality: 0.9,
      scanImageCropByTagRadius: 0,
      scanReticle: 'disabled',
      waitForReply: 'disabled',
      contextScanImageFileFormat: 'j',
    },
    bdemo: {
      cameraZoom: 3,
      circleDetection: 'disabled',
      scanType: 'digital_anticopy',
      scanImageFileFormat: 'j',
      maximumScanFrequencyInMs: 1000,
      sendingForVerificationDisplayTimeoutInMilliseconds: 60000,
      sendingForVerificationDisplayTimeout: 5000,
      reticleFingerprint: 'disabled',
      digitalAnticopyAlgorithm: 'auto_samplepack4_orion_beige',
      finalImagelongestEdgeLength: 1000,
      scanImageCompressionQuality: 0.9,
      scanImageCropByTagRadius: 0,
      scanReticle: 'disabled',
      waitForReply: 'disabled',
      contextScanImageFileFormat: 'j',
    },
    q: {
      circleDetection: 'disabled',
      scanImageFileFormat: 'j',
      maximumScanFrequencyInMs: 1000,
      sendingForVerificationDisplayTimeoutInMilliseconds: 60000, //Make this value arbitrarily large so that it's effectively disabled for digital_anticopy scans
      reticleFingerprint: 'disabled',
      scanImageCompressionQuality: 0.9,
      scanImageCropByTagRadius: 0,
      scanReticle: 'disabled',
      waitForReply: 'disabled',
      contextScanImageFileFormat: 'j',
    },
    awh: {
      circleDetection: 'disabled',
      scanImageFileFormat: 'j',
      maximumScanFrequencyInMs: 1000,
      sendingForVerificationDisplayTimeoutInMilliseconds: 60000, //Make this value arbitrarily large so that it's effectively disabled for digital_anticopy scans
      reticleFingerprint: 'disabled',
      scanImageCompressionQuality: 0.9,
      scanImageCropByTagRadius: 0,
      scanReticle: 'disabled',
      waitForReply: 'disabled',
      contextScanImageFileFormat: 'j',
    },
  }

  let parameters = CONFIG_PRESETS.default

  const init = () => {
    const configPreset = getUrlSetting('cfg') || 'default'
    parameters = CONFIG_PRESETS.default
    if (configPreset !== 'default') {
      if (CONFIG_PRESETS[configPreset]) {
        Object.keys(CONFIG_PRESETS[configPreset]).forEach((key) => {
          parameters[key] = CONFIG_PRESETS[configPreset][key]
        })
      }
    }

    getUrlSetting('cz') && (parameters.cameraZoom = Number(getUrlSetting('cz')))
    const pValue = getUrlSetting('p')
    console.log('p URL parameter:', pValue)
    pValue && (parameters.previewMode = Number(pValue))
    console.log('previewMode after setting:', parameters.previewMode)
    getUrlSetting('mv') && (parameters.matchEngineVersion = Number(getUrlSetting('mv')))
    getUrlSetting('mdc') && (parameters.maxDetectDistanceFromCenterOfReticle = Number(getUrlSetting('mdc')))
    getUrlSetting('r') && (parameters.preferredCameraResolution = getUrlSetting('r'))
    getUrlSetting('ff') && (parameters.scanImageFileFormat = getUrlSetting('ff'))
    getUrlSetting('rm') && (parameters.scanImageCropByTagRadius = Number(getUrlSetting('rm')))
    getUrlSetting('qrrm') && (parameters.scanImageCropByQRCodeWidth = Number(getUrlSetting('qrrm')))
    getUrlSetting('qrmin') && (parameters.qrCodeMinimumSize = Number(getUrlSetting('qrmin')))
    getUrlSetting('qrmax') && (parameters.qrCodeMaximumSize = Number(getUrlSetting('qrmax')))
    getUrlSetting('qrblur') && (parameters.qrCodeMinimumBlurRatio = Number(getUrlSetting('qrblur')))
    getUrlSetting('cd') && (parameters.circleDetection = getUrlSetting('cd'))
    getUrlSetting('qrd') && (parameters.qrCodeDetection = getUrlSetting('qrd'))
    getUrlSetting('st') && (parameters.scanType = getUrlSetting('st'))
    getUrlSetting('msf') && (parameters.maximumScanFrequencyInMs = Number(getUrlSetting('msf')))
    getUrlSetting('svdt') &&
      (parameters.sendingForVerificationDisplayTimeoutInMilliseconds = Number(getUrlSetting('svdt')))
    getUrlSetting('sr') && (parameters.scanReticle = getUrlSetting('sr'))
    getUrlSetting('rf') && (parameters.reticleFingerprint = getUrlSetting('rf'))
    getUrlSetting('daa') && (parameters.digitalAnticopyAlgorithm = getUrlSetting('daa'))
    getUrlSetting('lel') && (parameters.finalImagelongestEdgeLength = Number(getUrlSetting('lel')))
    getUrlSetting('sto') && (parameters.scanTimeoutInMilliseconds = Number(getUrlSetting('sto')))
    getUrlSetting('srs') && (parameters.scanReticleShape = getUrlSetting('srs'))
    getUrlSetting('srbs') && (parameters.scanReticleBorderStroke = getUrlSetting('srbs'))
    getUrlSetting('srw') && (parameters.scanReticleWidth = Number(getUrlSetting('srw')))
    getUrlSetting('srh') && (parameters.scanReticleHeight = Number(getUrlSetting('srh')))
    getUrlSetting('srt') && (parameters.scanReticleThickness = Number(getUrlSetting('srt')))
    getUrlSetting('srcc') && (parameters.scanReticleColourChange = getUrlSetting('srcc'))
    getUrlSetting('ncdcs') && (parameters.nonCircleDetectionCropSize = Number(getUrlSetting('ncdcs')))
    getUrlSetting('qrdcs') && (parameters.qrDetectionCropSize = Number(getUrlSetting('qrdcs')))
    getUrlSetting('qrsrf') && (parameters.qrScanRegionFractionOfImage = Number(getUrlSetting('qrsrf')))
    getUrlSetting('qrp') && (parameters.qrCodeParsing = getUrlSetting('qrp'))
    getUrlSetting('wfr') && (parameters.waitForReply = getUrlSetting('wfr'))
    getUrlSetting('plt') && (parameters.platform = getUrlSetting('plt'))
    getUrlSetting('lsb') && (parameters.legacyScannerButton = getUrlSetting('lsb'))
    getUrlSetting('lsl') && (parameters.legacyScannerLink = getUrlSetting('lsl'))
    getUrlSetting('rtoue') && (parameters.resetTimeoutOnUseEffect = getUrlSetting('rtoue'))
    getUrlSetting('n') && (parameters.showNavigation = Number(getUrlSetting('n')))
    getUrlSetting('f') && (parameters.showFooter = Number(getUrlSetting('f')))
    getUrlSetting('l') && (parameters.showLogo = Number(getUrlSetting('l')))
    getUrlSetting('cs') && (parameters.contextScan = getUrlSetting('cs'))
    getUrlSetting('cff') && (parameters.contextScanImageFileFormat = getUrlSetting('cff'))
    parameters.contextScanImageCompressionQuality =
      getUrlSetting('cq') ||
      (parameters.contextScanImageFileFormat === 'j' ? 0.92 : parameters.contextScanImageFileFormat === 'w' ? 0.8 : 0)
    getUrlSetting('cncdcs') && (parameters.contextNonCircleDetectionCropSize = Number(getUrlSetting('cncdcs')))
    getUrlSetting('clel') && (parameters.contextFinalImagelongestEdgeLength = Number(getUrlSetting('clel')))

    parameters.scanImageCompressionQuality =
      getUrlSetting('q') ||
      (parameters.scanImageFileFormat === 'j' ? 0.92 : parameters.scanImageFileFormat === 'w' ? 0.8 : 0)
  }

  const getConfigParameter = (name) => {
    try {
      return parameters[name]
    } catch (err) {
      return null
    }
  }

  const reinit = () => {
    init()
  }

  init()

  instance = { getConfigParameter, reinit }

  return instance
}

export default ConfigManager
